<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">设备编号</label>
            <em class="weui-form-preview__value">{{ form.main.eq_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="eq_name">
            <label class="weui-form-preview__label">{{customLabel.eq_name || "设备名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.eq_orispeccode || "规格型号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_orispeccode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_brand">
            <label class="weui-form-preview__label">{{customLabel.eq_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_brand
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_kind">
            <label class="weui-form-preview__label">{{customLabel.eq_kind || "设备类别"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_kind
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="eq_check_time">
            <label class="weui-form-preview__label">{{customLabel.eq_check_time || "检查周期"}}</label>
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'year'"
              >{{ form.main.eq_check_time }}年</span
            >
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'month'"
              >{{ form.main.eq_check_time }}月</span
            >
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'week'"
              >{{ form.main.eq_check_time }}周</span
            >
            <span
              class="weui-form-preview__value"
              v-if="form.main.eq_check_period == 'day'"
              >{{ form.main.eq_check_time }}日</span
            >
          </div>
          <div class="weui-form-preview__item" slot="eq_state">
            <label class="weui-form-preview__label">{{customLabel.eq_state || "设备状态"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.eq_state
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ed_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="ed_project">
            <label class="weui-form-preview__label">{{customLabel.ed_project || "检查项目"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ed_project }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ed_method">
            <label class="weui-form-preview__label">{{customLabel.ed_method || "检查方法"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ed_method }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ed_standard">
            <label class="weui-form-preview__label">{{customLabel.ed_standard || "检查标准"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.ed_standard }}
            </span>
          </div>
          </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnin_spot_check"
        >转点检</a
      >
      <router-link
        :to="'/oa/equipment_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_remove"
        >删除</a
      >
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import Share from "@/components/button/Share.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    Share,
  },
  data() {
    return {
      baseUrl: "/api/oa/equipment",
      codeField: "eq_code",
      statusField: "eq_audit_status_code",
      caller: "Equipment",
      xtype: "oa-equipment-formpanel",
      form: {
        main: {},
        items1: [],
      },
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.eq_code,
        bizType: "Equipment",
        bizId: main.id,
        viewType: "oa-equipment-formpanel",
        title: "设备信息" + main.eq_code,
      };
    },
  },
  methods: {
    turnin_spot_check() {
      var me = this;
       me.$router.push({
            name: "OaEquipmentCheckEdit",
            params: {
              form:me.form
            }
          });
    },
  },
};
</script>